import React, { FC, useRef } from 'react';
import { Paper } from '@mui/material';

import { useTranslate } from 'src/shared/providers';

import { NotificationsForm } from './NotificationsForm';

export const NotificationsSection: FC = () => {
  const { t } = useTranslate();
  const ref = useRef<HTMLDivElement | null>(null);

  const handleScrollToBottom = () => {
    if (!ref.current) {
      return;
    }

    ref.current.scrollIntoView();
  };

  return (
    <Paper id="notifications-card" className="h-100 p-4 position-relative">
      <div className="d-flex flex-wrap flex-lg-nowrap mb-3">
        <div className="mb-3">
          <h4 className="pb-0 mb-0">{t('settings.notifications')}</h4>
          <label className="text-muted d-block">
            {t('settings.updateYourEmailAndSMSNotificationPreferencesInThisSection')}
          </label>
        </div>
      </div>
      <NotificationsForm showLabels onReset={handleScrollToBottom} />
      <div ref={ref} />
    </Paper>
  );
};
